import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const WhatsAppButton = ({ number }) => {
  const handleClick = () => {
    const url = `https://wa.me/${number}`;
    window.open(url, "_blank");
  };

  return (
    <button className="icon-button" onClick={handleClick}>
      <FontAwesomeIcon icon={faWhatsapp} />
    </button>
  );
};

export default WhatsAppButton;
